import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/news";

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const getById = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/getById", payload);
}

const add = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/add", payload);
}

const edit = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const newApi = {
    search,
    getById,
    add,
    edit,
    remove
}

export default newApi;